import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconDonationPage = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect x="1" y="1" width="16" height="15" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <path d="M1 8H17" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7.5 4H10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4.5 11H13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default IconDonationPage
